import {
  createRouter, createWebHistory, RouteLocationNormalized,
} from 'vue-router';
import GuestLayout from '../layout/GuestLayout.vue';
import AppLayout from '../layout/AppLayout.vue';
import AcceptInvitation from '../user/AcceptInvitation.vue';
import RecoverPassword from '../user/RecoverPassword.vue';
import ResetPassword from '../user/ResetPassword.vue';
import Login from '../auth/Login.vue';
import Dashboard from '../dashboard/Dashboard.vue';
import PendingReconnection from '../social/account/action/reconnect/PendingReconnection.vue';
import ClientProfile from '../client/profile/ClientProfile.vue';
import Report from '../report/Report.vue';
import Album from '../report/album/Album.vue';
import ClientAlbums from '../dashboard/client-user/ClientAlbums.vue';
import ClientPosts from '../dashboard/client-user/ClientPosts.vue';
import RouterView from './RouterView.vue';

const routes = [
  {
    path: '',
    component: AppLayout,
    children: [
      {
        path: '',
        name: 'dashboard',
        component: Dashboard,
      },
      {
        path: '/unreviewed',
        name: 'dashboard_unreviewed',
        component: Dashboard,
      },
      {
        path: '/escalated',
        name: 'dashboard_escalated',
        component: Dashboard,
      },
      {
        path: '/flagged',
        name: 'dashboard_flagged',
        component: Dashboard,
      },
      {
        path: '/albums',
        name: 'dashboard_albums',
        component: ClientAlbums,
      },
      {
        path: '/albums/:reportId',
        name: 'album',
        component: Album,
        props: true,
      },
      {
        path: '/social',
        component: RouterView,
        children: [
          {
            path: 'customers/:customerId/accounts/pending-reconnection',
            component: PendingReconnection,
            props: true,
          },
        ],
      },
      {
        path: '/clients/:clientId',
        component: RouterView,
        children: [
          {
            path: 'albums',
            component: ClientAlbums,
            props(route: RouteLocationNormalized) {
              return {
                clientId: parseInt(route.params.clientId as string, 10),
              };
            },
          },
          {
            path: 'posts',
            component: ClientPosts,
            props(route: RouteLocationNormalized) {
              return {
                clientId: parseInt(route.params.clientId as string, 10),
              };
            },
          },
          {
            path: '',
            name: 'client_profile',
            redirect(route: RouteLocationNormalized) {
              return {
                name: 'client_profile_tab',
                params: {
                  clientId: route.params.clientId,
                  tab: 'unreviewed',
                },
              };
            },
          },
          {
            path: ':tab',
            name: 'client_profile_tab',
            component: ClientProfile,
            props(route: RouteLocationNormalized) {
              return {
                clientId: parseInt(route.params.clientId as string, 10),
                tab: route.params.tab || 'unreviewed',
              };
            },
          },
        ],
      },
      {
        path: '/reports/:id',
        name: 'report',
        component: Report,
        props(route: RouteLocationNormalized) {
          return {
            reportId: parseInt(route.params.id as string, 10),
          };
        },
      },
    ],
  },
  {
    path: '',
    component: GuestLayout,
    children: [
      {
        path: '/accept-invitation/:token',
        name: 'accept_invitation',
        component: AcceptInvitation,
        props: true,
      },
      {
        path: '/recover-password',
        name: 'recover_password',
        component: RecoverPassword,
      },
      {
        path: '/reset-password/:token',
        name: 'reset_password',
        component: ResetPassword,
        props: true,
      },
      {
        path: '/login',
        name: 'login',
        component: Login,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes as any,
});

export default router;
